import { useTranslation } from 'react-i18next';
import { Link, Outlet } from '@tanstack/react-router';
import { useChangeLocale } from '@features/auth/model/locale';
import { LEGAL_DOCS } from '@features/legal/documents';
import { LanguageSwitcher, Logo, ThemeToggle } from '@shared/ui';

/** Public layout for sign-in, registration and token-link pages. */
export function AuthLayout() {
  const { t } = useTranslation(['common', 'legal']);
  const changeLocale = useChangeLocale();
  return (
    <div className="flex min-h-dvh flex-col bg-bg">
      <header className="flex items-center justify-between gap-2 px-page-x py-4 lg:px-8 print:hidden">
        <Link to="/login" aria-label={t('brand.home')} className="rounded-md">
          <Logo size={36} />
        </Link>
        <div className="flex items-center gap-1">
          <LanguageSwitcher showLabel onChange={(l) => void changeLocale(l)} />
          <ThemeToggle />
        </div>
      </header>
      <main id="main" tabIndex={-1} className="flex flex-1 flex-col justify-center px-page-x pb-12 pt-4 outline-none">
        <Outlet />
      </main>
      <footer className="px-page-x pb-6 text-center text-xs text-muted print:hidden">
        <p>{t('brand.tagline')}</p>
        <nav aria-label={t('legal:footer.label')} className="mt-2">
          <ul className="flex flex-wrap justify-center gap-x-4 gap-y-1">
            {LEGAL_DOCS.map((d) => (
              <li key={d.slug}>
                <Link to={`/legal/${d.slug}`} className="hover:text-primary hover:underline">
                  {t(`legal:docs.${d.slug}` as 'legal:docs.terms')}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </footer>
    </div>
  );
}
